<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Edit Purchase Invoice #{{data.code}}</h4>
                    <p class="text-subtitle-1">Purchase Invoice Edit Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseInvoiceForm 
                        v-model="data"
                        ref="form" 
                        v-if="!invoiceLoading"
                        edit-mode
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="handleSave">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleDiscard">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchaseInvoiceForm from "./../../components/purchase/PurchaseInvoiceForm";
import PAlert from './../../components/common/PAlert';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchaseinvoiceEditView",
    components: {
        PurchaseInvoiceForm,
        PAlert,
    },
    data() {
        return {
            id: null,
            data: null,
            alert: {
                value: false,
                title: "Alert",
                content: "are you sure",
                callback: null
            },
            loading: false,
            dataLoading: false,
            invoiceLoading: false,
            perm: permissions,
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/invoice/findByID",
            pushSupplier: "purchase/supplier/push",
            pushItem: "purchase/item/push",
            snackbar: "ui/snackbar/show",
            update: "purchase/invoice/update"
        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to save?", callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.$router.push({ name: "PurchaseInvoiceDisplay", params: { id: response.data.id }})
                this.snackbar({text: 'Purchase Invoice Updated', color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error; 
                this.snackbar({ text: message, color: "error"});
            }).finally(() => {
                this.loading = false
            })
        },
        handleDiscard() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to discard?", callback: this.discard }
        },
        discard() {
            this.$router.push({ name: "PurchaseInvoiceDisplay", params: { id: this.id }})
        },
        handleNewLine() {
            this.$refs.form.addLine();
        },
        fetchInvoice() {
            this.dataLoading = true;
            this.findByID(this.id).then(response => {
                this.data = this.prepareInvoiceForm(response.data);
            }).finally(() => {
                this.dataLoading = false;
            });
        },
        prepareInvoiceForm(invoice) {
            this.pushSupplier(invoice.supplier);
            return {
                ...invoice,
                supplier_id: invoice.supplier.id,
                account_id: invoice.account.id,
                purchase_order_id: invoice.purchase_order ? invoice.purchase_order.id : null,
                purchase_order_code: invoice.purchase_order ? invoice.purchase_order.code : null,
                lines: invoice.lines.map(line => {
                    this.pushItem(line.item);
                    return {
                        ...line,
                        item_id: line.item.id,
                        measure_unit_id: line.measure_unit.id,
                        tax_id: line.tax.id
                    }
                })
            }
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchInvoice();
    }
};
</script>

<style></style>
